import { getDefaultStore } from 'jotai';

import {
  sessionWindowsAtomFamily,
  type SessionWindowsState,
} from './sessionWindowsAtoms';

/**
 * Get session windows state from outside React components.
 * Use this in models, utilities, or legacy code that can't use hooks.
 */
export const getSessionWindowsState = (sessionId: string): SessionWindowsState => {
  const store = getDefaultStore();
  return store.get(sessionWindowsAtomFamily(sessionId));
};
